'use strict';

var _ = require('lodash');
var moment = require('moment');
var DatepickerDirective = function DatepickerDirective($filter, angularHelper, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  return {
    restrict: 'E',
    template: require('../templates/datepicker.html'),
    require: 'ngModel',
    replace: true,
    scope: {
      type: '@',
      format: '@',
      placeholder: '@',
      minDate: '=',
      maxDate: '=',
      positioning: '@',
      options: '=',
      emptyErrMsg: '@',
      disabledDate: '='
    },
    link: function link(scope, element, attrs, ctrl) {
      var momentFormat = scope.format;
      var format = momentService.getFormat(scope.format);
      var config = momentService.ruleTypeToConfig(scope.type) || momentService.getConfig(scope.type);
      var defaultOptions = {
        format: format,
        showTodayButton: true,
        toolbarPlacement: 'bottom',
        widgetPositioning: {
          vertical: scope.positioning
        },
        useCurrent: false,
        parseInputDate: function parseInputDate(inputDate) {
          if (moment.isMoment(inputDate)) {
            return inputDate;
          } else {
            return momentService.of(inputDate, config, format, this.useStrict, true).value;
          }
        }
      };
      scope.positioning = scope.positioning || 'bottom';
      var options = _.assign(defaultOptions, scope.options);
      element.datetimepicker(options);
      var picker = element.data('DateTimePicker');
      ctrl.$formatters.push(function (value) {
        if (momentService.isMoment(value) && value.isValid()) {
          return rmMomentFormat(value, momentFormat);
        }
        return '';
      });
      ctrl.$render = function () {
        var date = ctrl.$viewValue ? ctrl.$viewValue : null;
        picker.date(date);
      };
      var input = element.find('input');
      var button = element.find('button');
      input.prop('disabled', scope.disabledDate);
      button.prop('disabled', scope.disabledDate);
      input.on('focus', function () {
        if (ctrl.$viewValue === '' && !ctrl.$touched) {
          setDefaultDate();
        }
        picker.show();
        //triggering focus is needed for xt-forms validation for showing and hiding tooltips
        element.triggerHandler('focus');
      }).on('blur', function () {
        //triggering blur is needed for xt-forms validation for showing and hiding tooltips
        element.triggerHandler('blur');
      });

      //in case use strict mode datePicker will not try parse not valid date even by format.
      //and it is possible to update date on each keydown in this case
      if (options.useStrict) {
        input.on('input', function () {
          input.triggerHandler('change');
          if (input.val() === '') {
            ctrl.$setViewValue('');
          }
        });
      }
      element.on('dp.change', function () {
        var value = picker.date();
        var instant = value && value.valueOf();
        ctrl.$setViewValue(instant && momentService.of(instant, config));
        angularHelper.triggerDigest(scope);
      });
      element.on('dp.error', function (event) {
        if (input.val() === '' || !event.date) {
          ctrl.$setViewValue('');
        } else if (event.date) {
          var date = createValidMoment(event);
          ctrl.$setViewValue(date);
        }
        angularHelper.triggerDigest(scope);
      });
      scope.$watch('minDate', function () {
        if (scope.minDate) {
          if (isTimeFormat(scope.format)) {
            picker.maxDate(false);
          }
          picker.minDate(scope.minDate.value);
          if (isTimeFormat(scope.format)) {
            picker.maxDate(scope.minDate.endOf('day').value);
          }
        }
      });
      scope.$watch('maxDate', function () {
        if (scope.maxDate) {
          if (isTimeFormat(scope.format)) {
            picker.minDate(false);
          }
          picker.maxDate(scope.maxDate.value);
          if (isTimeFormat(scope.format)) {
            picker.minDate(scope.maxDate.startOf('day').value);
          }
        }
      });
      scope.err = ctrl.$error;
      scope.$on('$destroy', function () {
        picker.destroy();
      });
      function isTimeFormat(format) {
        return format === 'TIME' || format === momentService.TIME_USER_SETTINGS || format === 'TIME_ISO';
      }
      function setDefaultDate() {
        var defaultDate = momentService.systemNow(config);
        if (scope.minDate && defaultDate.isBefore(scope.minDate)) {
          defaultDate = momentService.copy(scope.minDate, config);
        }
        if (scope.maxDate && defaultDate.isAfter(scope.maxDate)) {
          defaultDate = momentService.copy(scope.maxDate, config);
        }
        if (scope.options && scope.options.enabledDates) {
          defaultDate = momentService.of(_.first(scope.options.enabledDates), config);
        }
        picker.date(defaultDate.value);
      }
      function createValidMoment(event) {
        var date = momentService.of(event.date, config);
        if (isTimeFormat(scope.format)) {
          var edgeDate = scope.minDate && !date.isAfter(scope.minDate) && scope.minDate;
          edgeDate = edgeDate || scope.maxDate && !date.isBefore(scope.maxDate) && scope.maxDate;
          date = edgeDate ? edgeDate.set({
            h: date.hours(),
            m: date.minutes()
          }) : date;
        }
        return date;
      }
    }
  };
};
DatepickerDirective.$inject = ['$filter', 'AngularHelper', 'MomentService'];
module.exports = DatepickerDirective;